import React, { Component } from 'react'
import {
  extendBaseClass,
  extend,
  extendParentClass,
} from '../../../utils/classes'

export class SectionHeader extends Component {
  extendParentClass = extendParentClass.bind(this)

  getBaseClass = () => {
    const { parentClass } = this.props
    if (parentClass) {
      return this.extendParentClass('header')
    }
    return 'section__header'
  }

  baseClass = this.getBaseClass()

  extend = extendBaseClass.bind(this)

  contentClass = this.extend('content')

  extendContentClass = (childClass) => extend(this.contentClass, childClass)

  render() {
    const { title, description, headline } = this.props
    return (
      <div className={this.baseClass}>
        <div className={this.contentClass}>
          <h5 className={this.extendContentClass('headline')}>{headline}</h5>
          <h2 className={this.extendContentClass('title')}>{title}</h2>
          <p className={this.extendContentClass('description')}>
            {description}
          </p>
        </div>
      </div>
    )
  }
}

export default SectionHeader
